<template>
    <div class="mosaic">
        <ul>
            <li v-for="(item, index) in items" :key="item.image">
                <img
                    :src="item.image"
                    :alt="item.description"
                    @click="openLightbox(item.image, index)"
                    class="mosaic-image"
                    loading="lazy"
                />
            </li>
        </ul>

        <div
            v-if="selectedImage"
            class="lightbox-overlay"
            @click="closeLightbox"
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @touchend="handleTouchEnd"
        >
            <button
                class="lightbox-close"
                @click.stop="closeLightbox"
                aria-label="close"
            >
                <i class="fa fa-times"></i>
            </button>

            <div class="lightbox-content" @click.stop>
                <img
                    class="lightbox-image"
                    :src="selectedImage"
                    :alt="selectedDescription"
                    :style="{ transform: `translateX(${swipeOffset}px)` }"
                />

                <button
                    v-if="currentIndex > 0"
                    class="lightbox-nav lightbox-nav--prev"
                    @click.stop="previousImage"
                    aria-label="previous image"
                >
                    previous
                </button>
                <button
                    v-if="currentIndex < items.length - 1"
                    class="lightbox-nav lightbox-nav--next"
                    @click.stop="nextImage"
                    aria-label="next image"
                >
                    next
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.mosaic-lightbox-opened {
    overflow: hidden;

    .page {
        position: relative;
        z-index: 99;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            selectedImage: null,
            selectedDescription: null,
            currentIndex: 0,
            touchStartX: null,
            touchStartY: null,
            swipeOffset: 0,
            minSwipeDistance: 50
        };
    },
    methods: {
        openLightbox(image, index) {
            this.currentIndex = index;
            this.selectedImage = image;

            document.body.classList.add("mosaic-lightbox-opened");
            document.addEventListener("keydown", this.handleKeydown);

            this.swipeOffset = 0;
        },
        closeLightbox() {
            this.selectedImage = null;
            this.selectedDescription = null;

            document.body.classList.remove("mosaic-lightbox-opened");
            document.removeEventListener("keydown", this.handleKeydown);

            this.swipeOffset = 0;
            this.touchStartX = null;
            this.touchStartY = null;
        },
        previousImage() {
            if (this.currentIndex > 0) {
                this.currentIndex--;
                this.selectedImage = this.items[this.currentIndex].image;

                this.swipeOffset = 0;
            }
        },
        nextImage() {
            if (this.currentIndex < this.items.length - 1) {
                this.currentIndex++;
                this.selectedImage = this.items[this.currentIndex].image;

                this.swipeOffset = 0;
            }
        },
        handleKeydown(event) {
            if (event.key === "ArrowLeft") {
                this.previousImage();
            } else if (event.key === "ArrowRight") {
                this.nextImage();
            } else if (event.key === "Escape") {
                this.closeLightbox();
            }
        },
        handleTouchStart(event) {
            const touch = event.touches[0];

            this.touchStartX = touch.clientX;
            this.touchStartY = touch.clientY;
        },
        handleTouchMove(event) {
            if (this.touchStartX === null || this.touchStartY === null) {
                return;
            }

            const touch = event.touches[0];
            const deltaX = touch.clientX - this.touchStartX;
            const deltaY = touch.clientY - this.touchStartY;

            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                event.preventDefault();
                this.swipeOffset = deltaX;
            }
        },
        handleTouchEnd(event) {
            if (this.touchStartX === null || this.touchStartY === null) {
                return;
            }

            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - this.touchStartX;
            const deltaY = touch.clientY - this.touchStartY;

            if (
                Math.abs(deltaX) > Math.abs(deltaY) &&
                Math.abs(deltaX) > this.minSwipeDistance
            ) {
                if (deltaX > 0) {
                    this.previousImage();
                    return;
                } else {
                    this.nextImage();
                }
            } else {
                this.swipeOffset = 0;
            }

            this.touchStartX = null;
            this.touchStartY = null;
        }
    },
    beforeDestroy() {
        // Quem trava o scroll e a classe adicionada em openLightbox, nao o
        // style inline: limpar style.overflow deixava o body travado quando o
        // componente era destruido com o lightbox aberto.
        document.body.classList.remove("mosaic-lightbox-opened");
        document.removeEventListener("keydown", this.handleKeydown);
    }
};
</script>
